export const COOKIE_CONSENT_STORAGE_KEY = "mutzur_cookie_consent_v1";

export type AnalyticsConsentState = "granted" | "denied" | "unset";

export function getAnalyticsMeasurementId() {
  const value = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
  return value?.length ? value : "";
}
